import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/Locations/ResultsData";

const updateResultsData: Reducer<ResultsData> = (
  state: ResultsData = new ResultsData(),
  action: Action<ActionType, ResultsData>
) => {
  switch (action.type) {
    case ActionType.LOCATIONS_DATA_FETCHED:
      let fetchedItems = action.data.businessData,
        showMore = false;
      if (action.data.totalRecords > fetchedItems.length) {
        showMore = true;
      }
      return { ...state, items: fetchedItems, showMore, total: action.data.totalRecords };
    case ActionType.STATIONS_LOCATIONS_ALL_DATA_FETCHED:
      let allItems = action.data.businessData;
      return { ...state, allItems: allItems };
    case ActionType.STATIONS_LOCATIONS_ALL_DATA_UPDATED:
      return { ...state, allItems: action.data };
    default:
      return state;
  }
};

export default updateResultsData;
